import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import flagAr from '../../flags/ar.svg';
import flagBg from '../../flags/bg.svg';
import flagCs from '../../flags/cs.svg';
import flagDa from '../../flags/da.svg';
import flagDe from '../../flags/de.svg';
import flagEs from '../../flags/es.svg';
import flagFi from '../../flags/fi.svg';
import flagFr from '../../flags/fr.svg';
import flagGb from '../../flags/gb.svg';
import flagHi from '../../flags/hi.svg';
import flagHu from '../../flags/hu.svg';
import flagId from '../../flags/id.svg';
import flagIt from '../../flags/it.svg';
import flagJa from '../../flags/ja.svg';
import flagKo from '../../flags/ko.svg';
import flagMs from '../../flags/ms.svg';
import flagNl from '../../flags/nl.svg';
import flagNo from '../../flags/no.svg';
import flagPl from '../../flags/pl.svg';
import flagPt from '../../flags/pt.svg';
import flagSk from '../../flags/sk.svg';
import flagSv from '../../flags/sv.svg';
import flagTa from '../../flags/ta.svg';
import flagTh from '../../flags/th.svg';
import flagTl from '../../flags/tl.svg';
import flagTr from '../../flags/tr.svg';
import flagVi from '../../flags/vi.svg';
import flagZh from '../../flags/zh.svg';
import flagZhTW from '../../flags/zhTW.svg';

import StyledBox from './styles';

export const supportedLanguages = [
  'ar', 'bg', 'cs', 'da', 'de', 'en', 'es', 'fi',
  'fr', 'hu', 'it', 'nl', 'no', 'pl', 'pt', 'sk', 'sv', 'tr',
  'zh', 'zh_tw', 'ja', 'hi', 'id', 'vi', 'th', 'ta', 'ko', 'tl', 'ms',
];

const flagMap: Record<string, string> = {
  ar: flagAr,
  bg: flagBg,
  cs: flagCs,
  da: flagDa,
  de: flagDe,
  en: flagGb,
  es: flagEs,
  fi: flagFi,
  fr: flagFr,
  hu: flagHu,
  it: flagIt,
  nl: flagNl,
  no: flagNo,
  pl: flagPl,
  pt: flagPt,
  sk: flagSk,
  sv: flagSv,
  tr: flagTr,
  zh: flagZh,
  // eslint-disable-next-line camelcase
  zh_tw: flagZhTW,
  ja: flagJa,
  hi: flagHi,
  id: flagId,
  vi: flagVi,
  th: flagTh,
  ta: flagTa,
  ko: flagKo,
  tl: flagTl,
  ms: flagMs,
};

export function LanguageFlag(props: { language: string }) {
  const { language } = props;
  const { t } = useTranslation('common');
  const flagSrc = flagMap[language];
  return flagSrc
    ? <img src={flagSrc} alt={t(`languages.flag.${language}`)} />
    : <Typography>{language}</Typography>;
}

export default function LanguageIndicator(props: { language: string }) {
  const { language } = props;
  const { t } = useTranslation('common');

  return (
    <StyledBox>
      <LanguageFlag language={language} />
      <Typography>{t(`languages.${language}`)}</Typography>
    </StyledBox>
  );
}
